/**
 * Language Reactor
 *
 * Language-learning overlay for streaming sites; page scripts exposed to all origins.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 5.1.8.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'hoombieeljmmljlkjmnheibnpciblicm';
export const languageReactor: ExtensionDefinition = {
  id: ID,
  name: "Language Reactor",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 2000000,
  notes: "Language-learning overlay for streaming sites; page scripts exposed to all origins.",
  signals: [
    { id: 'war-pagescript-dioco-min-js', kind: 'web-accessible-resource',
      description: 'Fetch pageScript_dioco.min.js, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'pageScript_dioco.min.js') },
    { id: 'war-pagescript-lly-min-js', kind: 'web-accessible-resource',
      description: 'Fetch pageScript_lly.min.js, exposed to every origin.',
      weight: 0.5, run: () => probeFetch(ID, 'pageScript_lly.min.js') },
  ],
};
